import React from 'react'
import { useState,useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormSelectSeller from '../../../../components/forms/formSelectSeller';
import GreenButton from '../../../../components/forms/greenButton';
import ApiUrl from '../../../../configTools/apiUrl';

const Topsellers = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [sellers, setSellers] = useState([]);
    const [seller, setSeller] = useState({username:'Select', id:0});
    const [sellerList, setSellerList] = useState([]);
    const post_search = ()=>{
        const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
        if(seller.id === 0 || seller.id === ''){
            toast.update(toastid, { render: 'Fields Empty', type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        let Body = {
            userid : seller.id
        };
        fetch(ApiUrl.API_URL_TopSeller, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify(Body)
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                get_admin_list();
                setTimeout(() => {
                  toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                }, 500);
            }
            else{
                setTimeout(() => {
                  toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                }, 500);
            }
        });
    }
    const get_admin_list = () =>{
        fetch(ApiUrl.API_URL_TopSeller)
        .then(res=>res.json())
        .then(data =>{
            setSellers(data);
        });
    }
    const delete_admin = (id) =>{
        fetch(ApiUrl.API_URL_TopSellerDelete+"/"+id,{
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          }
        })
        .then(res=>res.json())
        .then(data =>{
          if(data.success){
            get_admin_list();
          }
          else{
            console.log(data.responce);
          }
        });
    }
    useEffect(()=>{
        fetch(ApiUrl.API_URL_TopSeller)
        .then(res=>res.json())
        .then(data =>{
            setSellers(data);
        });
        fetch(ApiUrl.API_URL_TopSellerSelect)
        .then(res=>res.json())
        .then(data =>{
            setSellerList(data);
        });
    },[])
  return (
    <div className='admin_forms_container'>
        <h3 style={{padding:"10px 0px", fontWeight:"500", fontSize:"20px"}}>Top Sellers</h3>
        <div className='admin_forms_multirow'>
            <div className='admin_col_25'>
                <FormSelectSeller Lable="Seller" Value={seller} setValue={setSeller} Options={sellerList}/>
                <GreenButton Value={'Add'} Action={()=>{post_search()}}/>
            </div>
            {
                sellers.map((item,index)=>{
                    return(
                        <div className='admin_col_25' key={index}>
                            <div className='admin_forms_container'>
                                <div style={{cursor:"pointer"}}>
                                    <div style={{
                                        backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+item.image})`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        width: "100%",
                                        paddingTop: "80%",
                                        borderRadius: "3px",
                                        border: "2px solid black",
                                        position:"relative"
                                    }}>
                                        <div style={{
                                            position:"absolute",
                                            width:"20%",
                                            top:"0",
                                            right:"0"
                                        }}>
                                        <GreenButton Value='X' Action={()=>{
                                            delete_admin(item.id);
                                        }}/>
                                        </div>
                                    </div>
                                    <div style={{padding:"10px 0px"}}>
                                        <h3>{item.firstname} {item.lastname}</h3>
                                        <h3>{item.username}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
      <ToastContainer />
    </div>
  )
}

export default Topsellers
